module.exports = __webpack_public_path__ + "media/images/landing_page/header_pc-4deb0d69061b04a0b465da3c91e3ab3d.png";